Vue.component('ow-ajax', {


  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div")
  },
  staticRenderFns: [],

  name: 'ow-ajax',
  props: ['method', 'url', 'body', 'params', 'trigger', 'headers'],
  methods: {
    rxReadCookie: function rxReadCookie(cName) {
      var rslt = new RegExp(cName + "=([^;]+)\\;?", "i").exec(document.cookie ? unescape(document.cookie) : "");
      return rslt ? rslt[1] : "";
    },
    responseHandler: function responseHandler(component, xhr, method) {
      var isSuccess = false;
      switch (method.toLowerCase()) {
        default:
          break;
        case 'post':
        case 'put':
          isSuccess = xhr.status === 200 || xhr.status === 201 || xhr.status === 202;
          break;
        case 'get':
          isSuccess = xhr.status === 200;
          break;
        case 'delete':
          isSuccess = xhr.status === 200;
          break;
      }
      try {
        isSuccess ? component.$emit('success', {
          response: JSON.parse(xhr.response),
          status: xhr.status
        }) : component.$emit('error', {
          xhr: xhr
        });
      } catch (ex) {
        alert(ex.message);
        component.$emit('error', {
          xhr: xhr
        });
      }
    },
    makeXHR: function makeXHR() {
      var _this = this;

      var that = this;

      var urlWithParams = Object.keys(this.params || {}).reduce(function(url, key, i) {
        return i === 0 ? url + '?' + key + '=' + _this.params[key] : url + '&' + key + '=' + _this.params[key];
      }, this.url);
      var method = this.method || 'GET';
      var xhr = new XMLHttpRequest();

      xhr.open(method || 'GET', urlWithParams);

      xhr.timeout = 18000;

      var headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'csrf-token': this.rxReadCookie("XSRF-TOKEN"),
        'Content-Type': 'application/json'
      };
      if (this.headers) {
        Object.keys(this.headers).forEach(function(key) {
          return headers[key] = _this.headers[key];
        });
      }
      Object.keys(headers).forEach(function(key) {
        return xhr.setRequestHeader(key, headers[key]);
      });

      xhr.addEventListener('readystatechange', function() {
        if (this.readyState === XMLHttpRequest.DONE) {
          that.responseHandler(that, this, method);
        }
      });

      xhr.send(JSON.stringify(this.body));
    }
  },
  mounted: function mounted() {
    if (this.trigger) {
      this.makeXHR();
    }
  },
  watch: {
    trigger: function trigger(value) {
      if (value) {
        this.makeXHR();
      }
    }
  }


});